import Box from './Box';
import Logo from './Logo';

export default function ToggleButton({ open, onClick = () => {} }) {
	return (
		<Box name="toggle-button" classes={open ? ['shrink'] : []} component="button" onClick={onClick}>
			<Logo />
			<Box>Assistant</Box>
		</Box>
	);
}
